import 'angular:locale/data:en';
import 'zone.js';
import './apps/web/src/polyfills.ts';(globalThis.$localize ??= {}).locale = "___NG_LOCALE_INSERT___";
